import { Component, HostListener, Input, OnInit, SimpleChanges } from '@angular/core'
import * as $ from 'jquery'
import { getImageRedirectUrl } from '../../../../../../../helper/common'
import { SharedServices } from '../../../../../../services/shared.services'
import { AuthService } from '../../../../../../services/auth.services'
import { RestServices } from '../../../../../../services/rest.services'
import { FormBuilder } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { MatrixServices } from '../../../../../../services/image/matrix.services'
import * as moment from 'moment'

@Component({
    selector: 'app-comparison-slide',
    templateUrl: './comparison-slide.component.html',
    styleUrls: [
        './comparison-slide.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
    ],
})
export class ComparisonSlideComponent implements OnInit {
    @Input() defaultIndex: Number = 0
    @Input() arrData: any[] = []
    @Input() sideName: string = ''
    @Input() dataTabName: string = 'tooth-all'

    dateFormat: string = 'YYYY.MM.DD ddd'

    option_Comparison: String = 'hidden'
    option_com: String = 'active'

    senMax: any = 100
    tabName: string = 'tooth-all'
    images: any[] = []
    arrComparison: any[] = []
    arrayComparison: any[] = []

    valChange: any = 0
    enableImage: boolean = false
    index: any = 0
    showDate: any = ''
    width: any
    height: any

    arrImage: any[] = []

    imageId: string = ''
    imageUrl: string = ''
    imageStyle: any
    currentDateNumber: number
    maxIndex: number = 0

    matrixImage: any[] = []
    oldHeight: any
    oldWidth: any

    imageSize: string = 'large'

    constructor(
        private _sharedService: SharedServices,
        private authData: AuthService,
        private restApi: RestServices,
        private formBuider: FormBuilder,
        private route: ActivatedRoute,
        private clientTopServices: ClientTopServices,
        public matrixServices: MatrixServices,
    ) {
    }

    ngOnInit() {
        this.resetMatrix()
        this.option_Comparison = 'active'
        this.valChange = 0
        if (window.orientation != undefined) {
            const tmpW = $(window).innerWidth()
            this.width = (tmpW - 300) / 2
            this.height = (this.width * 2) / 3
        } else {
            if ($(window).innerWidth() != window.screen.width) {
                const tmpW = $(window).innerWidth()
                this.width = (tmpW - 300) / 2
                this.height = (this.width * 2) / 3
            } else if ($(window).innerHeight() != window.screen.height) {
                const tmpH = $(window).innerHeight()
                this.height = tmpH - 400
                this.width = (this.height * 3) / 2
            } else {
                const tmpW = $(window).innerWidth()
                this.width = (tmpW - 300) / 2
                this.height = (this.width * 2) / 3
            }
        }

        this.oldHeight = this.height
        this.oldWidth = this.width
        this.resizeUser()
        this.resizeFullScreen()
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.arrData) {
            this.images = changes.arrData.currentValue
        }
        let tabName = this.tabName
        if (changes.dataTabName) {
            tabName = changes.dataTabName.currentValue
        }

        this.filterCollection(tabName, this.defaultIndex)
    }

    ngOnDestroy() {
    }

    resizeFullScreen() {
        this.clientTopServices.changeEmitted$.subscribe((screen) => {
            if (
                screen != null &&
                screen != undefined &&
                screen['status'] != undefined
            ) {
                if (screen['status'] == 'active') {
                    this.height = this.oldHeight
                    this.width = this.oldWidth
                } else if (screen['status'] == 'hidden') {
                    if (window.orientation != undefined) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 300) / 2
                        this.height = (this.width * 2) / 3
                    } else {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 2
                            this.height = (this.width * 2) / 3
                        } else if (
                            $(window).innerHeight() != window.screen.height
                        ) {
                            const tmpH = $(window).innerHeight()
                            this.height = tmpH - 300
                            this.width = (this.height * 3) / 2
                        }
                    }
                }
                console.log(this.width)
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (window.orientation != undefined) {
            const tmpW = $(window).innerWidth()
            this.width = (tmpW - 300) / 2
            this.height = (this.width * 2) / 3
        } else {
            if ($(window).innerWidth() != window.screen.width) {
                const tmpW = $(window).innerWidth()
                this.width = (tmpW - 300) / 2
                this.height = (this.width * 2) / 3
                console.log('dk1')
            } else if ($(window).innerHeight() != window.screen.height) {
                const tmpH = $(window).innerHeight()
                this.height = tmpH - 400
                this.width = (this.height * 3) / 2
                console.log('dk2')
            } else {
                const tmpW = $(window).innerWidth()
                this.width = (tmpW - 300) / 2
                this.height = (this.width * 2) / 3
                console.log('dk3')
            }
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(
            (status) => {
                if (status != null && status['status'] != undefined) {
                    const tmp: any = status['status']
                    if (tmp == 'in') {
                        if (window.orientation != undefined) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 2
                            this.height = (this.width * 2) / 3
                        } else {
                            if ($(window).innerWidth() != window.screen.width) {
                                const tmpW = $(window).innerWidth()
                                this.width = (tmpW - 300) / 2
                                this.height = (this.width * 2) / 3
                            } else if (
                                $(window).innerHeight() != window.screen.height
                            ) {
                                const tmpH = $(window).innerHeight()
                                this.height = tmpH - 400 - 100
                                this.width = (this.height * 3) / 2
                            } else {
                                const tmpH = $(window).innerHeight()
                                this.height = tmpH - 400 - 100
                                this.width = (this.height * 3) / 2
                            }
                        }
                    } else {
                        if (window.orientation != undefined) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 2
                            this.height = (this.width * 2) / 3
                        } else {
                            if ($(window).innerWidth() != window.screen.width) {
                                const tmpW = $(window).innerWidth()
                                this.width = (tmpW - 300) / 2
                                this.height = (this.width * 2) / 3
                            } else if (
                                $(window).innerHeight() != window.screen.height
                            ) {
                                const tmpH = $(window).innerHeight()
                                this.height = tmpH - 400
                                this.width = (this.height * 3) / 2
                            }
                        }
                    }
                    console.log(this.width)
                    this.oldHeight = this.height
                    this.oldWidth = this.width
                }
            },
        )
    }

    resetMatrix() {
        this.matrixServices.arrRotate = [0, 0]
        this.matrixServices.arrStyleImage = [0, 0]
        this.matrixServices.arrFlip = [
            {
                horizontalFlip: 1,
                verticalFlip: 1,
            },
            {
                horizontalFlip: 1,
                verticalFlip: 1,
            },
        ]
    }

    filterCollection(tabName, defaultIndex) {
        this.tabName = tabName
        let index = defaultIndex
        if (this.images.length > 0) {
            this.arrComparison = this.images.filter(
                (item) =>
                    item[tabName] && item[tabName][0] && item[tabName][0]['id'],
            )

            if (this.currentDateNumber) {
                //find last date
                index = this.arrComparison.findIndex((item) => {
                    return this.currentDateNumber == item['dateStringToInit']
                })

                if (index == -1) index = defaultIndex
            }
        } else {
            this.arrComparison = []
        }

        this.showImage(index)
    }

    renderCalendarRange() {
        this.showDate = ''
        this.maxIndex =
            this.arrComparison.length >= 1 ? this.arrComparison.length - 1 : 0
    }

    getIndexArray(index) {
        //change on slide
        if (this.maxIndex > 0) {
            if (index < 1) {
                index = 0
            } else if (index > this.maxIndex) {
                index = this.maxIndex
            }
            if (index == 0) {
                this.index = 0
                this.valChange = 0
            } else if (index == this.maxIndex) {
                this.index = index
                this.valChange = 100
            } else {
                const tmpEarch: number = this.senMax / this.maxIndex
                const assignCalculate = Math.round(tmpEarch)
                this.valChange = index * assignCalculate
                this.index = index
            }
        } else {
            this.index = 0
            this.valChange = 0
        }
    }

    showImage(index: any = null) {
        this.enableImage = false
        this.matrixImage = []
        this.renderCalendarRange()
        this.getIndexArray(index)
        let compareItem: any[]
        if (this.arrComparison.length > 0) {
            compareItem = this.arrComparison[this.index]
            this.arrayComparison = compareItem[this.tabName]
        }
        if (compareItem) {
            this.currentDateNumber = compareItem['dateStringToInit']
            this.showDate = moment(this.currentDateNumber).format(
                this.dateFormat,
            )

            const el = compareItem[this.tabName][0]
            if (el) {
                if (el['matrix'] != undefined) {
                    this.matrixImage.push(el['matrix'])
                } else {
                    this.matrixImage.push([1, 0, 0, 1])
                }
                if (el['id'] != undefined && el['id'] != '') {
                    if (this.tabName.includes('movie')) {
                        this.imageUrl = el['id']
                    } else {
                        this.imageUrl = getImageRedirectUrl(el['id'], this.imageSize)

                    }
                    this.imageId = el['id']
                    this.enableImage = true
                } else {
                    this.imageUrl = ''
                    this.imageId = ''
                    this.enableImage = false
                }
            }
        }
    }

    changeOnRange(valueUsageChange) {
        const value: any = valueUsageChange
        let index = 0
        if (this.maxIndex > 0) {
            const tmp: number = (value / this.senMax) * this.maxIndex
            index = Math.round(tmp)
        }

        this.showImage(index)
    }

    prevDate(day) {
        let index = 0
        if (day == 0) {
            index = 0
        } else {
            index = this.index - 1
        }
        this.showImage(index)
    }

    nextDate(day) {
        let index = 0
        if (day == 100) {
            index = this.maxIndex
        } else {
            index = this.index + 1
        }
        this.showImage(index)
    }

    actionVideo(sideName) {
        const video: any = document.getElementById(
            'comparision-video-' + sideName,
        )
        if (video) {
            if (video.paused) {
                video.play()
            } else {
                video.pause()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/comparison/comparison-slide/comparison-slide.component.ts